import _ from 'lodash'
class OrderHistoryController {
    /*@ngInject*/
    constructor($sce, siteLinksService, orderService, scrollToService, environment) {
        this.$sce = $sce;
        this.siteLinksService = siteLinksService;
        this.orderService = orderService;
        this.scrollToService = scrollToService;
        this.environment = environment;
    }
    
    $onInit() {
        this.USER_TYPE = this.environment.USER_TYPE;
        this.scrollTo = this.scrollToService.scrollTo;
        this.continueShoppingLink = this.siteLinksService.continueShoppingLink;
        this.orders = this.orderHistoryModel.error ? null: this.extendOrderWithBranchNameHtml();
        this.selectedOrderId = null;
        this.orderDetails = null;
        this.isLoadingOrderDetails = false;
        this.showOrderDetails = false;
        this.happinessImage = require('../../../public/images/delivering-happiness.png');
    }

    extendOrderWithBranchNameHtml() {
        var _self = this;
        
        return _.map(this.orderHistoryModel, function(element) {
            return _.extend({}, element, {
                fulfillmentBranchNameHtml: _self.$sce.trustAsHtml(element.fulfillment.branchName)
            });
        });
    }
    
    toggleViewOrder(orderId) {
        
        if(this.selectedOrderId == orderId) {
            this.hideOrder();
        }
        else {
            this.viewOrder(orderId);
        }
    }
    
    viewOrder(orderId) {
        
        var _self = this;
        _self.isLoadingOrderDetails = true;
        _self.selectedOrderId = orderId;

        this.orderService.retrieveOrderDetails(orderId).then(function(response){
            
            _self.orderDetails = response;
            _self.isLoadingOrderDetails = false;
            _self.scrollTo('.order-history-listing', 90);
            _self.showOrderDetails = true;
        }, function(error) {
            
            _self.isLoadingOrderDetails = false;
            _self.scrollTo('.order-history-listing', 90);
        });
    }
    
    hideOrder() {
        this.showOrderDetails = false;
        this.selectedOrderId = null;
        this.orderDetails = null;
        this.scrollTo('.order-history-listing', 90);
    }
}

export default OrderHistoryController;


// WEBPACK FOOTER //
// ./src/app/components/order-history/order-history.controller.js